module.exports = "https://cdn.redage.net/src/views/games/other/images/maps/mafia1.png";